export default "__VITE_ASSET__ChFHVeLU__"